import type { Store } from '@blocksuite/affine/store';
import { classifyDatabaseRole } from '@streamlain/view-config';

/**
 * Locate the ViewConfig database block in a BlockSuite doc.
 *
 * The block is identified by `flavour === 'affine:database'` AND
 * role metadata. Searching by flavour alone would collide with user-owned
 * databases. Loads the page parts that may hold databases first.
 *
 * Resolves null if no such block exists.
 */
export async function findViewConfigBlockId(
  doc: Store
): Promise<string | null> {
  const blockIds =
    await doc.pageStructure.loadBlockIdsOfKind('affine:database');
  return (
    blockIds.find(blockId => {
      const blockMap = doc.pageStructure.blockFields(blockId);
      const modelProps = doc.getBlock(blockId)?.model.props as
        | Record<string, unknown>
        | undefined;
      return (
        classifyDatabaseRole(
          key => blockMap?.get(`prop:${key}`) ?? modelProps?.[key]
        ) === 'config'
      );
    }) ?? null
  );
}
